<template>
  <div>
    <v-dialog v-model="dialog" width="75%">
      <v-card>
        <v-card-title class="mx-3">
          <span class="headline">{{
            $t("MovePositionOrder.StockBatchDialog.stockBatchDetails")
          }}</span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
                fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("$vuetify.close") }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-data-table
              :headers="stockBatchHeaders"
              :items="stockPositionBatchItems"
              :loading="loading"
              multi-sort
              disable-pagination
              hide-default-footer
              class="elevation-0 px-6"
              fixed-header
              height="360px"
            >
              <template v-slot:item.stock_detail.stock_batch_code="{ item }">
                {{ item.stock_detail.stock_batch_code }}
                <v-chip
                  v-if="item.stock_detail.expired_flg"
                  x-small
                  label
                  :color="item.stock_detail.expired_flg | expiredFlgsColor"
                  :text-color="
                    item.stock_detail.expired_flg | expiredFlgsTextColor
                  "
                >
                  {{ item.stock_detail.expired_flg | expiredFlgsText }}
                </v-chip>

                <v-chip
                  v-if="item.stock_detail.prohibit_flg"
                  small
                  label
                  :color="item.stock_detail.prohibit_flg | prohibitFlgsColor"
                  :text-color="
                    item.stock_detail.prohibit_flg | prohibitFlgsTextColor
                  "
                >
                  {{ item.stock_detail.prohibit_flg | prohibitFlgsText }}
                </v-chip>
              </template>
              <template v-slot:item.price="{ item }">
                {{ $t("Global.money") }}
                {{ item.price }}
              </template>
              <template v-slot:item.out_num="{ item }">
                {{ item.out_num }}&nbsp;{{ item.unit }}
              </template>
              <template v-slot:item.production_date="{ item }">
                {{ item.production_date | formatDate }}
              </template>
              <template v-slot:item.expired_date="{ item }">
                {{ item.expired_date | formatDate }}
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="dialog = false">{{
            $t("$vuetify.close")
          }}</v-btn>
          <v-btn color="accent" @click="dialog = false">
            {{ $t("StockContainers.selectContainer.confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import i18n from "@/i18n";
import { mapState } from "vuex";

export default {
  name: "SelectStockBatchDialog",

  props: {
    value: Boolean,
    label: String,
    currentItem: Object,
    stockId: Number,
  },

  components: {
  },

  computed: {
    stockPositionBatchItems() {
      return this.stockPositionBatchs;
    },
    stockBatchHeaders() {
      var headers = [
        {
          text: i18n.t(
            "MovePositionOrder.StockBatchDialog.DetailFieds.material"
          ),
          align: "center",
          sortable: false,
          value: "MaterialDescription",
        },
      ];
      headers.push(
        {
          text: i18n.t(
            "MovePositionOrder.StockBatchDialog.DetailFieds.stock_batch_code"
          ),
          align: "center",
          sortable: false,
          value: "stock_batch_code",
        },
        {
          text: i18n.t("MovePositionOrder.StockBatchDialog.DetailFieds.price"),
          align: "center",
          sortable: false,
          value: "price",
        },
        {
          text: i18n.t("MovePositionOrder.StockBatchDialog.DetailFieds.out_num"),
          align: "center",
          sortable: false,
          value: "out_num",
        },
        {
          text: i18n.t(
            "MovePositionOrder.StockBatchDialog.DetailFieds.production_date"
          ),
          align: "center",
          sortable: false,
          value: "production_date",
        },
        {
          text: i18n.t(
            "MovePositionOrder.StockBatchDialog.DetailFieds.expired_date"
          ),
          align: "center",
          sortable: false,
          value: "expired_date",
        }
      );
      return headers;
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "accountUser"]),
  },

  data: () => ({
    dialog: false,
    stockPositionBatchs: [],
  }),

  methods: {
    getBatchData() {
      if (this.currentItem) {
        this.stockPositionBatchs = this.currentItem.stock_details.map((batch) => {
          const MaterialDescription = i18n.t(
            this.settings
              ? this.settings.material_name_display_type == 4
                    ? "Material.nameWithCodeAndStandard"
                    : this.settings.material_name_display_type == 3
                ? "Material.materialNameWithCodeAndStandard"
                  : this.settings.material_name_display_type == 2
                  ? "Material.materialNameWithCode"
                : "Material.materialName"
              : "Material.materialName",
              [
                batch.material.material_code,
                batch.material.material_name,
                batch.material.standard_name,
              ]
          );
          return Object.assign({}, batch, {MaterialDescription});
        })
      }
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value) {
          this.dialog = true;
          this.getBatchData()
        }
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
      },
    },
  },
};
</script>